export enum UserRole {
  ADMIN = 'Admin',
  PARTNER = 'Partner',
}


// WEBPACK FOOTER //
// ./src/constants/UserRole.ts